module.exports = __webpack_public_path__ + "static/media/photographer_woman.f8298530.jpg";